var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("投保模版预览"),
      width: 400,
      closable: false,
      maskClosable: false
    },
    model: {
      value: _vm.previewVisible,
      callback: function ($$v) {
        _vm.previewVisible = $$v;
      },
      expression: "previewVisible"
    }
  }, [_c("div", {
    staticClass: "modal"
  }, [_c("h4", [_vm._v(_vm._s(_vm.$t("填写投保信息")))]), _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "part"
    }, [_c("div", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.type))]), _c("div", {
      staticClass: "bgc"
    }, _vm._l(item.child, function (item1, i) {
      return _c("div", {
        key: i
      }, [_c("div", {
        staticClass: "content1"
      }, [_c("span", {
        staticClass: "left"
      }, [item1.isRequired ? _c("span", {
        staticStyle: {
          color: "red"
        }
      }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item1.name))]), _c("span", {
        staticClass: "right"
      }, [_vm._v("xx "), item1.isSend ? _c("span", {
        staticClass: "code"
      }, [_vm._v(_vm._s(_vm.$t("发送验证码")))]) : _vm._e()])])]);
    }), 0)]);
  })], 2), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.closeAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };